export const URLAPISUBIDA = 'https://obtenerpromo.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://obtenerpromo.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://obtenerpromo.com/notis/'

export const URLAPISUBIDAPDF = 'https://obtenerpromo.com/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://obtenerpromo.com/notis/'